module.exports = __webpack_public_path__ + "images/dashboard-safe@2x-94028a835861fb050901dcb82d0e55f0.png";